import { AddLibraryItemCard } from '@/components/AddLibraryItemCard';
import { upgradeFreePlanModalOpen } from '@/components/Modals/UpgradeFreePlanModal';
import { useNavigateToAdvancedEditor } from '@/hooks/navigation';
import { useFreeVideos } from '@/hooks/useFreeVideos';
import { useFlag } from '@/services/featureFlags';
import { useTemplateGalleryModal } from '@/state/template-gallery/useTemplateGalleryModal';
import styled from '@emotion/styled';
import { useSetRecoilState } from 'recoil';

const StyledAddLibraryItemCard = styled(AddLibraryItemCard)`
    width: 305px;
    height: 190px;
`;

export const CreateVideoTile = () => {
    const { outOfFreeVideos } = useFreeVideos();
    const setUpgradeFreePlanModalOpen = useSetRecoilState(upgradeFreePlanModalOpen);

    const { isLoading, navigateToAdvancedEditor } = useNavigateToAdvancedEditor();
    const { open } = useTemplateGalleryModal();
    const isTemplateGalleryEnabled = useFlag('template_gallery_v2', false);

    const handleCreateVideo = async () => {
        if (outOfFreeVideos) {
            setUpgradeFreePlanModalOpen(true);
            return;
        }

        if (isTemplateGalleryEnabled) {
            open();
            return;
        }
        await navigateToAdvancedEditor({
            mixPanelFrom: 'create-video-tile',
        });
    };

    return <StyledAddLibraryItemCard id="create-video-card" label="Create video" onClick={handleCreateVideo} loading={isLoading} />;
};
